import { render, staticRenderFns } from "./NQAWidget.vue?vue&type=template&id=cddb69e2"
import script from "./NQAWidget.vue?vue&type=script&lang=js"
export * from "./NQAWidget.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports